import { getWebSocketBaseUrl as getWebSocketBaseUrlFromUtils } from '@/utils/websocketUtils';

export const APP_CONFIG = {
  VERSION: import.meta.env.VITE_APP_VERSION || 'unknown',
  API_BASE_URL: import.meta.env.VITE_API_BASE_URL || '/api',
} as const;

export function getWebSocketBaseUrl(): string {
  return getWebSocketBaseUrlFromUtils(APP_CONFIG.API_BASE_URL);
}
